export default [
    {
        path: 'lead-sources',
        name: 'projects-lead-sources',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.lead_sources').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-lead-sources-list' },
        children: [
            {
                path: '',
                name: 'projects-lead-sources-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.lead_sources').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/lead-sources/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-lead-source-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::lead_sources.lead_source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/lead-sources/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-lead-source-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::lead_sources.lead_source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/lead-sources/item.vue'),
            },
        ]
    },
    {
        path: 'priorities',
        name: 'projects-priorities',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.priorities').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-priorities-list' },
        children: [
            {
                path: '',
                name: 'projects-priorities-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.priorities').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/priorities/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-priority-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::priorities.priority', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/priorities/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-priority-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::priorities.priority', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/priorities/item.vue'),
            },
        ]
    },
    {
        path: 'statuses',
        name: 'projects-statuses',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.statuses').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-statuses-list' },
        children: [
            {
                path: '',
                name: 'projects-statuses-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.statuses').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/statuses/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-status-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::statuses.status', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/statuses/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-status-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::statuses.status', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/statuses/item.vue'),
            },
        ]
    },
    {
        path: 'billable-categories',
        name: 'projects-billable-categories',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.billable_categories').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-billable-categories-list' },
        children: [
            {
                path: '',
                name: 'projects-billable-categories-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.billable_categories').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/billable-categories/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-billable-category-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::billable_categories.billable_category', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/billable-categories/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-billable-category-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::billable_categories.billable_category', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/billable-categories/item.vue'),
            },
        ]
    },
    {
        path: 'contract-types',
        name: 'projects-contract-types',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.contract_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-contract-types-list' },
        children: [
            {
                path: '',
                name: 'projects-contract-types-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.contract_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/contract-types/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-contract-type-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::contract_types.contract_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contract-types/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-contract-type-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::contract_types.contract_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contract-types/item.vue'),
            },
        ]
    },
    {
        path: 'target-value-types',
        name: 'projects-target-value-types',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.target_value_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-target-value-types-list' },
        children: [
            {
                path: '',
                name: 'projects-target-value-types-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.target_value_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/target-value-types/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-target-value-type-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::target_value_types.target_value_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/target-value-types/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-target-value-type-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::target_value_types.target_value_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/target-value-types/item.vue'),
            },
        ]
    },
    {
        path: 'project-sources',
        name: 'projects-sources',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.project_sources').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-sources-list' },
        children: [
            {
                path: '',
                name: 'projects-sources-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.project_sources').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/sources/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-source-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/sources/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-source-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/sources/item.vue'),
            },
        ]
    },
    {
        path: 'project-types',
        name: 'projects-project-types',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.project_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-project-types-list' },
        children: [
            {
                path: '',
                name: 'projects-project-types-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.project_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/project-types/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-project-type-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::project_types.project_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/project-types/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-project-type-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::project_types.project_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/project-types/item.vue'),
            },
        ]
    },
    {
        path: 'products',
        name: 'projects-products',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.products').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-products-list' },
        children: [
            {
                path: '',
                name: 'projects-products-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.products').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/products/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-product-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::products.product', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/products/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-product-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::products.product', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/products/item.vue'),
            },
        ]
    },
    {
        path: 'services',
        name: 'projects-services',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.services').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-services-list' },
        children: [
            {
                path: '',
                name: 'projects-services-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.services').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/services/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-service-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::services.service', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/services/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-service-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::services.service', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/services/item.vue'),
            },
        ]
    },
    {
        path: 'processes',
        name: 'projects-processes',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.processes').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-processes-list' },
        children: [
            {
                path: '',
                name: 'projects-processes-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.processes').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/processes/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-process-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::processes.process', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/processes/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-process-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::processes.process', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/processes/item.vue'),
            },
        ]
    },
];